export const setLocalStorageItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    return false;
  }
};

export const getLocalStorageItem = (key: string) => {
  const data = localStorage.getItem(key);
  try {
    return data === null ? null : JSON.parse(data);
  } catch (e) {
    return data;
  }
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
